import type { DesktopProps } from "~/components/header/index"
import Searchbar from "~/components/search/Searchbar"

import Account from "~/components/header/account/desktop"
import Contacts from "~/components/header/contacts/index"
import Links from "~/components/header/links/index"
import Logo from "~/components/header/logo/index"
import Orders from "~/components/header/orders/index"
import Navbar from "~/components/header/navbar/desktop"
import CartButton from "~/components/cart/Button"

export default function DesktopHeader({
    contacts,
    links,
    searchbar,
    navItems,
    logo,
    cart,
    isHome,
}: DesktopProps) {
    const items = navItems ?? []

    // Antes isto era `throw new Error('Missing freeShippingValue')`. No Fresh o
    // throw era inofensivo; aqui o `SectionErrorBoundary` do framework
    // transforma qualquer throw de section num
    // `<div data-section-error class="hidden">` em produção (blocks/src/hooks/
    // SectionErrorFallback.tsx:60) — ou seja, o header INTEIRO (barra de
    // contatos, logo, navbar, busca, conta, sacola) desaparece sem nenhum sinal
    // visual, e o boundary é um class component que nunca se reseta.
    //
    // Isso é acionável por dois caminhos que não existiam no Fresh:
    //   1. `LoadingFallback` recebe `Partial<Props>` e o framework passa objeto
    //      vazio de propósito (DecoPageRenderer.tsx:442-444, "rawProps are no
    //      longer serialized to the client");
    //   2. re-render no cliente com props mais magras que as do SSR.
    //
    // `freeShippingValue` só alimenta a barra de frete grátis do dropdown do
    // carrinho, que é lazy-mounted no hover — não justifica derrubar o topo do
    // site. `CartButton` agora não monta o dropdown quando o valor falta.
    if (!cart?.freeShippingValue) {
        console.error(
            '[Header] cart.freeShippingValue ausente — dropdown do carrinho desabilitado',
        )
    }

    return (
        <>
            {(contacts?.length || links?.length) && (
                <div className='text-xs text-white bg-black'>
                    <div className='flex items-center justify-between py-3 px-4 mx-auto max-w-[1810px]'>
                        {Boolean(contacts?.length) && <Contacts contacts={contacts!} />}

                        <ul className='flex items-center justify-center gap-5'>
                            {Boolean(links?.length) && <Links links={links!} />}
                        </ul>
                    </div>
                </div>
            )}

            <header className='h-[90px]'>
                <div className='relative w-full h-full text-white bg-wine'>
                    <div className='flex items-center justify-between w-full h-full gap-3 px-4 mx-auto max-w-[1810px]'>
                        <div className='flex items-center justify-center h-full gap-5'>
                            <Logo isHome={isHome} logo={logo} />
                            <Navbar items={items} />
                        </div>

                        <div className='flex items-center justify-end h-full gap-8 grow shrink-0'>
                            <div className='w-[240px]'>
                                <Searchbar {...searchbar} />
                            </div>

                            <div className='flex h-full gap-8 text-sm shrink-0'>
                                <Account />
                                <Orders />

                                <CartButton {...(cart ?? {})} />
                            </div>
                        </div>
                    </div>
                </div>
            </header>
        </>
    )
}
